import logo from '../../assets/logo.png';
import NavMenu from './NavMenu';
import HeaderActions from './HeaderActions';

export default function Navbar({ cartCount, mobileOpen, onMenuToggle }) {
  return <div className="navbar"><div className="header-container navbar__inner">
    <a className="brand" href="/" aria-label="Trillium Paws home"><img src={logo} alt="Trillium Paws" /></a>
    <NavMenu />
    <HeaderActions cartCount={cartCount} mobileOpen={mobileOpen} onMenuToggle={onMenuToggle} />
  </div></div>;
}
